import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Check, Upload } from "lucide-react";
import React, { useEffect, useState } from "react";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import { getVendorsList, getPartAndAccessoriesList } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import toast from "react-hot-toast";

const Partdetails = ({ issueDetails, setVendorList, vendorList, getVendorsListAPI, getIssuePartDetailsAPI }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [form, setForm] = useState({});
  const [partAccessoriesList, setPartandAccessoriesList] = useState({});
  const [uploadedImages, setUploadedImages] = useState(null);
  const addPartDetailsFiels = [
    {
      label: "Repair Type",
      value: "repairtype",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "self", value: "Self" },
        { key: "vendor", value: "Vendor" },
      ],
    },
    {
      label: "Vendor",
      value: "vendor",
      type: "dropdown",
      disabled: false,
      subCategory: Object.entries(vendorList).map(([id, item]) => ({
        value: item?.name,
        label: item?.id,
      })),
    },
    {
      label: "Part",
      value: "part",
      type: "dropdown",
      disabled: false,
      subCategory: Object.entries(partAccessoriesList).map(([key, value]) => ({
        value: value,
        label: key,
      })),
    },
    {
      label: "Part Name",
      value: "partname",
      type: "text",
      disabled: false,
    },
    {
      label: "Part Code",
      value: "partcode",
      type: "text",
      disabled: false,
    },
    {
      label: "Task",
      value: "task",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "changes", value: "Changed" },
        { key: "repaired", value: "Repaired" },
      ],
    },
    {
      label: "Repair By",
      value: "repairby",
      type: "text",
      disabled: false,
    },
    {
      label: "Odometer Reading",
      value: "odometerreading",
      type: "number",
      disabled: false,
    },
    {
      label: "Labour Charges",
      value: "labourcharges",
      type: "number",
      disabled: false,
    },
    {
      label: "Tax",
      value: "tax",
      type: "number",
      disabled: false,
    },
    {
      label: "Total Cost",
      value: "totalcost",
      type: "number",
      disabled: false,
    },
    {
      label: "Upload Files",
      value: "uploadfiles",
      type: "file",
      disabled: false,
    },
  ];

  useEffect(() => {
    getVendorsListAPI();
    getPartAndAccessoriesListAPI();
  }, []);


  const getPartAndAccessoriesListAPI = async (vehicleRegistration) => {
    const apiDetails = await getPartAndAccessoriesList(vehicleRegistration);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setPartandAccessoriesList(data);
  };

  const handleChange = async (field, value) => {
    if (field !== "uploadfiles") {
      setForm((prev) => ({ ...prev, [field]: value }));
    } else {
      await uploadmutiplefile(value, "vehicles", "vehicle").then((res) => {
        let filterImages = res?.uploaded?.map((image) => image?.url);
        setUploadedImages(filterImages);
        setForm((prev) => ({
          ...prev,
          image: res?.uploaded || "",
        }));
      });
    }
  };

  const handleAddPartDetails = async () => {
    let isTrue = partAccessoriesList[form?.partname] ? true : false;
    try {
      const response = await fetch(`${apiUrl}/api/issuepartdetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          labourCharges: form?.labourcharges,
          partId: form?.partcode,
          partName: form?.partname,
          repairType: form?.repairtype,
          task: form?.task,
          taxAmount: form?.tax,
          totalCost: form?.totalcost,
          issueId: issueDetails?.id,
          vehicleId: issueDetails?.vehicleId,
          attachments: JSON.stringify(form?.image),
          partCode: form?.partcode,
          isInventoryPart: isTrue,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setForm({
          currentOdometer: null,
        });
        toast.success("Part Details added successfully against the issue");
        await getIssuePartDetailsAPI(issueDetails?.id)
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  return (
    <>
      <div className="flex-1 p-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {addPartDetailsFiels.map((field, index) => (
            <div key={index} className="group">
              <label className="block mb-2 font-semibold text-gray-700 text-sm">
                {field.label}
                {field.required && <span className="text-red-500 ml-1">*</span>}
              </label>

              {field.type === "dropdown" ? (
                <FormControl
                  fullWidth
                  size="small"
                  className="transition-all duration-200 hover:shadow-md"
                >
                  <InputLabel id={`drop-label-${index}`}>
                    {field?.label}
                  </InputLabel>
                  <Select
                    labelId={`drop-label-${index}`}
                    value={form[field.value] || ""}
                    onChange={(e) => handleChange(field.value, e.target.value)}
                    label={field?.label}
                    sx={{
                      borderRadius: "8px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#e5e7eb",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#818cf8",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6366f1",
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 240,
                          borderRadius: "8px",
                          boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                        },
                      },
                    }}
                  >
                    {field?.subCategory
                      ?.filter((opt) => opt.item !== "inverted") // optional safety
                      .map((option, idx) => (
                        <MenuItem
                          key={idx}
                          value={option.key ?? option.label ?? option.value}
                        >
                          {option.value}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              ) : field.type === "file" ? (
                <div className="space-y-3">
                  <div className="relative">
                    <input
                      disabled={field.disabled}
                      type="file"
                      id={`file-${index}`}
                      multiple
                      onChange={(e) =>
                        handleChange(field.value, e.target.files)
                      }
                      className="hidden"
                      accept="image/*"
                    />
                    <label
                      htmlFor={`file-${index}`}
                      className={`flex items-center justify-center gap-2 w-full border-2 border-dashed rounded-lg p-4 transition-all duration-200 ${
                        field.disabled
                          ? "bg-gray-100 cursor-not-allowed"
                          : "border-indigo-300 hover:border-indigo-500 hover:bg-indigo-50 cursor-pointer"
                      }`}
                    >
                      <Upload size={20} className="text-indigo-600" />
                      <span className="text-sm text-gray-600">
                        {form[field.value] ? "Change file" : "Upload file"}
                      </span>
                    </label>
                  </div>
                  {form[field.value] && (
                    <div className="relative rounded-lg overflow-hidden shadow-md border-2 border-gray-200">
                      <img
                        src={
                          form[field.value].Location ||
                          form[field.value].path ||
                          form[field.value].url
                        }
                        className="w-full h-32 object-cover"
                        alt="Preview"
                      />
                      <div className="absolute top-2 right-2 bg-green-500 text-white p-1 rounded-full">
                        <Check size={16} />
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <input
                  disabled={field.disabled}
                  type={field.type}
                  value={form[field.value] || ""}
                  onChange={(e) => handleChange(field.value, e.target.value)}
                  className={`w-full border rounded-lg px-4 py-2.5 text-sm transition-all duration-200 ${
                    field.disabled
                      ? "bg-gray-100 cursor-not-allowed"
                      : "border-gray-300 hover:border-indigo-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                  } outline-none`}
                  placeholder={`Enter ${field.label.toLowerCase()}`}
                />
              )}
            </div>
          ))}
        </div>

        {uploadedImages?.length > 0 && (
          <div className="mt-6 flex gap-4 flex-wrap">
            {uploadedImages.map((image, index) => (
              <img
                key={index}
                src={image}
                alt="uploaded"
                className="w-44 h-44 rounded-lg object-cover border shadow"
              />
            ))}
          </div>
        )}

        <div className="flex justify-center mt-8">
          <Button
            sx={{
              bgcolor: "#0c4bc0ff",
              fontWeight: 500,
              px: 2,
              color: "white",
              borderRadius: 1,
              width: "200px",
              cursor: "pointer",
              "&:hover": {
                bgcolor: "#083a9a",
              },
            }}
            onClick={handleAddPartDetails}
          >
            Add Part
          </Button>
        </div>
      </div>
    </>
  );
};

export default Partdetails;
